import { JourneyEnums } from "@/types/Dashboard";
import { DecodedToken, DecodedUrlToken } from "@/types/User";
import { jwtDecode } from "jwt-decode";
import { JWT } from "next-auth/jwt";

export const getValidScope = (journey: string) => {
  switch (journey) {
    case JourneyEnums.CREDIT_CARD:
      return "credit-card";
    case JourneyEnums.PERSONAL_LOAN:
      return "personal-loan";
    case JourneyEnums.SECURED_LOAN:
      return "secured-loan";
    case JourneyEnums.OFFLINE_CARD:
      return "offline-card";
    default:
      return "web-bff-api";
  }
}

export const checkValidScopes = (token: JWT, decodedUrlToken: DecodedUrlToken) => {
  // check if the scope matches the urlToken otherwise sign out user
  const decodedToken = jwtDecode<DecodedToken>(token.accessToken as string)
  const isScopesMatching = token.accessToken && decodedToken.scope.includes(getValidScope(decodedUrlToken.journey))
  const isSubjectIdMatching = token.accessToken && decodedToken.subjectGuid.includes(decodedUrlToken.subjectGuid)
  const isSubjectGuidMatching = token.accessToken && decodedToken.iss.includes(decodedUrlToken.iss)

  return isScopesMatching && isSubjectIdMatching && isSubjectGuidMatching
}